export function parseProjectContextSearchParams(searchParams: URLSearchParams) {
  const environmentKeys = new Set(searchParams.getAll('env'));
  const selectedEnvironmentKey = searchParams.get('selected-env') ?? '';
  const selectedViewKey = searchParams.get('selected-view') ?? undefined;
  return { environmentKeys, selectedEnvironmentKey, selectedViewKey } as const;
}

export type ProjectContextSearchParams = ReturnType<typeof parseProjectContextSearchParams>;
